import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon } from 'lucide-react';
export type Crumb = {
  label: string;
  to?: string;
};
type PageHeroProps = {
  eyebrow: string;
  title: string;
  intro?: string;
  crumbs?: Crumb[];
  image?: string;
  imageAlt?: string;
  actions?: React.ReactNode;
  meta?: React.ReactNode;
};
export function PageHero({
  eyebrow,
  title,
  intro,
  crumbs,
  image,
  imageAlt = '',
  actions,
  meta
}: PageHeroProps) {
  return <section className="bg-ink" aria-labelledby="page-title" data-id="element-551" data-mp="r4ai0fzfqe0n">
      <div className={`mx-auto grid max-w-content gap-10 px-4 py-12 sm:px-6 lg:px-10 lg:py-16 ${image ? 'lg:grid-cols-12 lg:items-center' : ''}`} data-id="element-552" data-mp="m3wi5l7zmadp">
        <div className={image ? 'lg:col-span-7' : ''} data-id="element-553" data-mp="d9zzige17g31">
          {crumbs && crumbs.length > 0 && <nav aria-label="Breadcrumb" className="mb-6" data-id="element-554" data-mp="19tqsnw4u3mus">
              <ol className="flex flex-wrap items-center gap-1.5 text-[13px] text-white/50" data-id="element-555" data-mp="152h4kzyxorl0">
                {crumbs.map((crumb, index) => <li key={crumb.label} className="flex items-center gap-1.5" data-id="element-556" data-mp="2pyd7cjxnxos9" data-mpi={index}>
                    {crumb.to ? <Link to={crumb.to} className="transition-colors duration-150 ease-emphasis hover:text-white" data-id="element-557" data-mp="2uvde6x2c6vkf">
                        {crumb.label}
                      </Link> : <span className="text-white/80" data-id="element-558" data-mp="275rhqhdcmug4">{crumb.label}</span>}
                    {index < crumbs.length - 1 && <ChevronRightIcon aria-hidden className="h-3.5 w-3.5 text-white/30" data-id="element-559" data-mp="1x8efyhvzxfkf" />}
                  </li>)}
              </ol>
            </nav>}

          <p className="flex items-center gap-3 text-[13px] font-semibold uppercase tracking-[0.16em] text-gold-400" data-id="element-560" data-mp="3rme7xot7vwyg">
            <span aria-hidden className="h-px w-8 bg-gold-500" data-id="element-561" data-mp="gmlp0ik94gx" />
            {eyebrow}
          </p>
          <h1 id="page-title" className="mt-5 max-w-[20ch] font-display text-[34px] font-semibold leading-[1.06] tracking-[-0.025em] text-white sm:text-[46px] lg:text-[54px]" data-id="element-562" data-mp="3v4uzi0escifm">
            {title}
          </h1>
          {intro && <p className="mt-5 max-w-2xl text-[17px] leading-relaxed text-white/70 sm:text-[19px]" data-id="element-563" data-mp="3l7yvo7zu0khe">
              {intro}
            </p>}
          {meta && <div className="mt-6" data-id="element-564" data-mp="ho42rej08mzp">{meta}</div>}
          {actions && <div className="mt-8 flex flex-wrap items-center gap-4" data-id="element-565" data-mp="cqm20bf55e2s">{actions}</div>}
        </div>

        {image && <div className="lg:col-span-5" data-id="element-566" data-mp="7yu6dmh4oi5s">
            <div className="overflow-hidden rounded-media border border-white/10" data-id="element-567" data-mp="7xsszbcn3jkw">
              <img src={image} alt={imageAlt} className="aspect-[4/3] w-full object-cover" data-id="element-568" data-mp="3xiqw9ryxdbb" />
            </div>
          </div>}
      </div>
    </section>;
}